import type { HttpInterceptorFn } from '@angular/common/http'
import { catchError, throwError } from 'rxjs'
import { environment } from '../../../environments/environment'
import { SUPPORT_SESSION_KEY } from '../support/support-window.init'

const SUPPORT_HEADER = 'X-Support-Session'

/**
 * Seam 7. Attaches the per-window support credential to API requests. On a
 * 403 `support_session_invalid` (an expired/idle/ended credential) it clears ONLY
 * the window credential — never the cookie session (that is why the server uses
 * 403, not 401: the authInterceptor's logout path only fires on 401).
 */
export const supportSessionInterceptor: HttpInterceptorFn = (req, next) => {
  if (!req.url.startsWith(environment.apiBase)) return next(req)
  const cred = typeof sessionStorage !== 'undefined' ? sessionStorage.getItem(SUPPORT_SESSION_KEY) : null
  const forwarded = cred ? req.clone({ headers: req.headers.set(SUPPORT_HEADER, cred) }) : req
  return next(forwarded).pipe(
    catchError((err) => {
      if (err?.status === 403 && err?.error?.error?.code === 'support_session_invalid') {
        if (typeof sessionStorage !== 'undefined') sessionStorage.removeItem(SUPPORT_SESSION_KEY)
      }
      return throwError(() => err)
    })
  )
}
